module.exports = __webpack_public_path__ + "img/App book.no.139812a8.png";